import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import {dateInDMY} from '../../Helpers';
import {FaImage} from "react-icons/fa";
import { SERVER_API } from '../../fileWithConstants'
const Fabricims = () => {   
  const [fabrics, setFabrics] = useState([]);
  const [chunkDates, setChunkDates]=useState([]);
 
  const getFabricData = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-ims-fabricdata`);
      //console.log(data)
      if(data?.success && data?.fabrics.length>0){
      
        
        const dt_arr = [];
        for(var i=89; i>0; i--){
          var ms = new Date().getTime() - (86400000*i);
          var newDate = dateInDMY(new Date(ms));
          dt_arr.push(newDate)
        }

        var ms = new Date().getTime();
        var newDate = dateInDMY(new Date(ms));
        dt_arr.push(newDate)

        console.log(dt_arr)
        const chunk = dt_arr.map((_, i, all) => all.slice(10*i, 10*i+10)).filter(x=>x.length);
        //console.log(chunk)
        setChunkDates(chunk)
        for(var k=0; k<chunk.length; k++){
          var start = chunk[k][0];
          var end = chunk[k][chunk[k].length-1];
          for(var j=0; j<data?.fabrics.length; j++){
            var p_id = data.fabrics[j].parent_id;
          }
        }

        setFabrics(data?.fabrics);

      }else{
        toast.error('Some thing went wrong while getting fabric data.')
      }
    } catch (error) {
      console.log(error)
    }
  }
useEffect(()=>{
  getFabricData();
},[]);

  return (
    <Layout title={'Fabric IMS'}>
        <div className='container'>
      
            <h1 className='page-title'>Fabric IMS</h1>
            <div className='row justify-content-center'>
            <div className='col-md-12'>
            <div className='table-box'>
            <table className="table table-responsive table-hover table-sticky">
            <thead>
            <tr className='align-item'>
            <th scope="col">#</th>
            <th scope="col" className='text-start'>Name</th>
            <th scope="col">
            Opening
           {/* <br/>
            {chunkDates.length>0 && chunkDates[0][0]} */}
          </th>
            
            {chunkDates?.map((dt, index)=>(
              <th scope="col" key={index}>
                  {dt[0]} 
                  <br/>To <br/>
                  {dt[(dt.length-1)]} 
              </th>
            ))}

            <th scope="col">
            Closing
            {/* <br/>
            {chunkDates.length>0 && chunkDates[(chunkDates.length-1)][(chunkDates[(chunkDates.length-1)].length-1)]} */}
            
          </th>
            <th scope="col">Price</th>
            <th scope="col">Total Price</th>
            </tr>
            </thead>
                <tbody>
                  {fabrics?.map((fb, index)=>(
                    <tr key={index}>
                      <td>{index+1}</td>
                      <td className='text-start'>
                      {fb.name} {fb.fabric_photo!==''?(
                        <Link to={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`} target='_blank'>
                        <FaImage/>
                        </Link>
                      )
                        :("")
                      }                
                      </td>   
                      <td>{fb.opening_qty}</td>                             
                      {chunkDates?.map((dt, i)=>(
                        <td key={i}>

                        {Number(fb[`in_${i+1}`])>0 && (
                          <span className='text-success'>
                          +{Number(fb[`in_${i+1}`]).toLocaleString("en-US")}
                          </span>
                        )}
                          
                          {Number(fb[`in_${i+1}`])>0? Number(fb[`cut_${i+1}`])>0? ',':'' :''} 
                         
                          {Number(fb[`cut_${i+1}`])>0 && (
                            <span className='text-danger'>
                            -{Number(fb[`cut_${i+1}`]).toLocaleString("en-US")}
                          </span>
                          )}
                         
                        </td>
                      ))}
                     
                      <td>{((Number(fb.total_qty))-(Number(fb.out_qty))).toLocaleString("en-US")}</td>
                      <td>{fb.price}</td>
                      <td>{ (((Number(fb.total_qty))-(Number(fb.out_qty)))*(fb.price)).toLocaleString("en-US") }</td>
                      
                      </tr>
                  ))}

                </tbody>
                </table>
            </div>

        </div>
        </div>
        </div>
    </Layout>
  )
}

export default Fabricims
